import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { PaneComponent } from '@rocksoft/cdk';

@Component({
  selector: 'ml-bluetooth-ui',
  templateUrl: './bluetooth.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PaneComponent, ReactiveFormsModule, AsyncPipe],
})
export class ManagedSettingsBluetoothComponent {
  private readonly fb = inject(UntypedFormBuilder);

  readonly bluetooth = output<boolean>();

  public readonly bluetoothForm = this.fb.group({
    bluetoothEnabled: [false],
  });

  get bluetoothEnabled() {
    return this.bluetoothForm.get('bluetoothEnabled') as UntypedFormControl;
  }

  onSubmit() {
    this.bluetooth.emit(this.bluetoothEnabled.value);
  }
}
